import PageList from "../abstract/PageList.js";
import GridWrapper from "../../su/GridWrapper.js";

export default class PageLookupList extends PageList {
    constructor() {
        super();
    }

    initList() {
        // h
        let h = this.getAvailableHeight();
        //
        this.theGrid = new GridWrapper($(".jsList"));

        let options = {
            dataSource: {
                // data: $data.rows,
            },
            sorting: {
                multiple: false,
                allowUnsort: false
            },
            paging: {
                pageSize: 12,
                pageLinksCount: 10
            },
            //rowHover: false,
            altRows: false,

            columns: [
                {
                    field: "Uid",
                    title: "Uid"
                },
                {
                    field: "LabelList",
                    title: "Label"
                },
                {
                    field: "StatusLabel",
                    title: "Status"
                },
                {
                    title: "ACTION",
                    width: "12.5%",
                    // field: "_idx",
                    columnTemplate: this.theGrid.prepareColumnTemplate($("#customActions"), this.initListButton.bind(this))
                }
            ],
            events: {
                dblclick: (ev) => {
                    let target = $(ev.target);
                    if (target.is('span')) target = target.parent();
                    let index = $('.sui-row').index($(target.parent()));
                    const row = $(target.parent());
                    const cell = $('.sui-cell', row)[0];
                    const Uid = $($('span', cell)[0]).text();
                    this.openDetailPageDblClick(Uid);
                }
            },
            // TODO
            scrolling: true,
            resizing: true,
            height: h + "px"
        }

        this.theGrid.create(options, this.data.rows);
        this.theGrid.enableSearch($(".jsListSearch"), {
            or: [
                { path: "Label", filter: "contains", value: "" },
                { path: "StatusLabel", filter: "contains", value: "" },
                { path: "Uid", filter: "contains", value: "" },
            ]
        });
        this.theGrid.init("jsList");
        $(".jsList").swidget().hideColumn("Uid");
        // var a = StateManager.getViewState("jsList")
        jQuery(window).on("resize.grid", this.onResize.bind(this));

        return;
    }

    openDetailPageDblClick(dataIndex) {
        try {

            let datalist = this.theGrid.data;
            let data = datalist.find(el => el.Uid === dataIndex);
            let args = StateManager._splitUrl(document.location.href);

            document.location.href = TheApp.Env.BaseUrlNls + "lookup/" + this.data.tableUid.toLowerCase() + "/detail/" + Base64.toBase64(data.Uid, true) + "?__pi=" + this.data.page.PageId;
           // document.location.href = "/lookup/" + Base64.toBase64(data.Uid.toLowerCase()) + "?__pi=" + this.data.page.PageId;
        }
        catch (ex) {

        }

    }

    //getAvailableHeight() {
    //	let a = jQuery(".js-size");
    //	let i = 0;
    //	for (let x = 0; x < a.length; x++) {
    //		i += jQuery(a[x]).outerHeight();
    //	}
    //	i += 50; // padding app container
    //	i += 78; // search box
    //	i += 143; // paging
    //	let h = jQuery(window).height() - i;
    //	return h;
    //}

    onResize(e) {
        //debugger;
        this.theGrid.setHeight(this.getAvailableHeight());
    }


}

